import { render, staticRenderFns } from "./reserveringen.vue?vue&type=template&id=0b71df3e&"
import script from "./reserveringen.vue?vue&type=script&lang=js&"
export * from "./reserveringen.vue?vue&type=script&lang=js&"
import style0 from "./reserveringen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "reserveringen.vue"
export default component.exports